/* Yerb: prepinani variant na produktovych kartach s kosikem (yh-shop, spotlight-band, yh-spotlight).
   Karta = [data-ysh-card]; chip = [data-ysh-chip] s data-id/price/flavor/desc/incl.
   Meni hidden input[name=id], cenu [data-ysh-price], popis [data-ysh-desc], vybavu [data-ysh-incl]
   a properties[Prichut i] ([data-ysh-prop]). Delegace na document, bezi jen jednou. */
(function () {
  if (window.__yshChips) return;
  window.__yshChips = true;
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-ysh-chip]');
    if (!chip) return;
    var card = chip.closest('[data-ysh-card]');
    if (!card) return;
    card.querySelectorAll('[data-ysh-chip]').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var id = card.querySelector('input[name="id"]');
    if (id && chip.dataset.id) id.value = chip.dataset.id;
    var price = card.querySelector('[data-ysh-price]');
    if (price && chip.dataset.price) price.textContent = chip.dataset.price;
    var was = card.querySelector('[data-ysh-was]');
    if (was && chip.dataset.was !== undefined) {
      if (chip.dataset.was) { was.textContent = chip.dataset.was + ' Kč'; was.hidden = false; }
      else { was.textContent = ''; was.hidden = true; }
    }
    var desc = card.querySelector('[data-ysh-desc]');
    if (desc && chip.dataset.desc !== undefined) desc.textContent = chip.dataset.desc;
    var incl = card.querySelector('[data-ysh-incl]');
    if (incl && chip.dataset.incl !== undefined) {
      incl.textContent = '';
      chip.dataset.incl.split(',').forEach(function (t) {
        t = t.trim();
        if (!t) return;
        var s = document.createElement('span');
        s.textContent = t;
        incl.appendChild(s);
      });
    }
    card.querySelectorAll('[data-ysh-prop]').forEach(function (p) { p.value = chip.dataset.flavor || ''; });
  });
})();
